import { ref, computed, onMounted, onUnmounted } from 'vue';
import store from '@/store';
import { config } from '@/config.js';

export function useFormularioPago(props, emit) {
    const paycometScriptLoaded = ref(false);
    let mutationObserver = null;

    const anosCaducidad = computed(() => {
        const arrAnos = [];
        const anoActual = new Date().getFullYear();
        for (let i = 0; i < 10; i++) {
            arrAnos.push(anoActual + i);
        }
        return arrAnos;
    });

    const loadPaycometScript = () => {
        if (paycometScriptLoaded.value) return;
        const paycometScript = document.createElement('script');
        paycometScript.setAttribute('src', 'https://api.paycomet.com/gateway/paycomet.jetiframe.js?lang=es');
        paycometScript.onload = () => {
            paycometScriptLoaded.value = true;
        };
        document.head.appendChild(paycometScript);
    };

    const waitForElm = selector => {
        return new Promise(resolve => {
            if (document.querySelector(selector)) {
                return resolve(document.querySelector(selector));
            }
            mutationObserver = new MutationObserver(() => {
                if (document.querySelector(selector)) {
                    resolve(document.querySelector(selector));
                    mutationObserver && mutationObserver.disconnect();
                }
            });
            mutationObserver.observe(document.body, {
                childList: true,
                subtree: true
            });
        });
    };

    const getPayToken = () => {
        waitForElm('#paycometPaymentForm input[name=paytpvToken]').then(elm => {
            // IMPORTANTE: el emit debe ser camelCase ('payToken') para que
            // tanto PagoPaycometForm (perfil) como CardPaymentForm (checkout)
            // — ambos `defineEmits(['payToken'])` — lo reciban correctamente.
            // Usar 'pay-token' (kebab-case) fue código muerto dejado por una
            // migración incompleta y rompía el flujo (el listener no recibía nada).
            emit('payToken', elm.value);
        });
    };

    const cancelarCompra = () => {
        window.location.reload();
    };

    onMounted(() => {
        loadPaycometScript();
    });

    onUnmounted(() => {
        if (mutationObserver) {
            mutationObserver.disconnect();
            mutationObserver = null;
        }
    });

    return {
        anosCaducidad,
        getPayToken,
        cancelarCompra
    };
}